import { render, staticRenderFns } from "./EditProfileFunctionModal.vue?vue&type=template&id=0c8390d4&scoped=true"
import script from "./EditProfileFunctionModal.vue?vue&type=script&lang=js"
export * from "./EditProfileFunctionModal.vue?vue&type=script&lang=js"
import style0 from "./EditProfileFunctionModal.vue?vue&type=style&index=0&id=0c8390d4&prod&scoped=true&lang=css"
import style1 from "./EditProfileFunctionModal.vue?vue&type=style&index=1&id=0c8390d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8390d4",
  null
  
)

export default component.exports